import { pickAll } from 'ramda'
import { API_STATES } from 'src/ducks/consts'
import { Conversation } from './records'
import { ensureChatId } from './helpers'

export const selectChatSessions = state => state.messages.chatSessions

export const selectOpenChatIds = state => state.messages.openChatIds

export const selectMinimizedChatIds = state => state.messages.minimizedChatIds

export const selectDockLimits = state => ({
  maxOpenChats: state.messages.maxOpenChats,
  maxDockChats: state.messages.maxDockChats
})

export const selectChatSessionById = (state, chatId) => {
  if (!chatId) return null
  return state.messages.chatSessions?.[chatId] || null
}

export const selectActiveChatId = state => {
  if (state.messages.activeChatId) {
    return state.messages.activeChatId
  }
  const [first] = state.messages.openChatIds || []
  return first || null
}

export const selectActiveChatSession = state => {
  const chatId = selectActiveChatId(state)
  return selectChatSessionById(state, chatId)
}

const getSessionOrDefault = state =>
  selectActiveChatSession(state) || Conversation()

export const selectIsAvailable = state => getSessionOrDefault(state).isAvailable
export const selectLastMessageRequest = state => state.messages.lastRequest
export const isMessagesListOpened = state => state.messages.listOpened === true
export const isConversationOpened = state =>
  (state.messages.openChatIds || []).length > 0 ||
  (state.messages.minimizedChatIds || []).length > 0

export const selectConversationDetails = state =>
  pickAll(
    ['receiverId', 'contextId', 'contextType', 'conversationId', 'chatId'],
    getSessionOrDefault(state)
  )

export const selectConversation = state => getSessionOrDefault(state)

export const selectInterlocutor = state =>
  getSessionOrDefault(state).interlocutor

export const selectConversationMessages = state =>
  getSessionOrDefault(state).messages

export const selectContextualMessages = state =>
  state.messages.contextualMessages

export const selectPersonalMessages = state => state.messages.personalMessages

export const selectMessagesCounters = state =>
  pickAll(
    [
      'allUnreadMessagesCount',
      'contextualMessagesCount',
      'personalMessagesCount'
    ],
    state.messages
  )

export const selectPersonalSearchResults = state =>
  state.messages.personalSearchResults

export const selectContextualSearchResults = state =>
  state.messages.contextualSearchResults

export const selectMessagesDetails = state => state.messages

export const isMessagesListLoading = state =>
  state.messages.listState === API_STATES.IN_PROGRESS

export const isConversationLoading = state =>
  state.messages.conversationState === API_STATES.IN_PROGRESS

export const isChatMuted = state => state.account.currentUser.isChatMuted

export const isConversationMuted = state =>
  getSessionOrDefault(state).isConversationMuted

export const selectOnlineUsers = state => state.messages.onlineUsers

export const selectConversationContextActions = state =>
  getSessionOrDefault(state).contextActions

export const isConversationContextLoading = state =>
  getSessionOrDefault(state).contextState === API_STATES.IN_PROGRESS

export const selectChatSessionDetailsByChatId = (state, payload) => {
  const chatId = ensureChatId(payload)
  return selectChatSessionById(state, chatId) || Conversation()
}

export const selectChatSessionsOrdered = state => {
  const order = state.messages.chatOrder || []
  const sessions = selectChatSessions(state) || {}
  return order.map(chatId => sessions?.[chatId]).filter(Boolean)
}
